import { Description as CertificateIcon } from '@material-ui/icons';
import { ReactComponent as DownloadIcon } from 'src/assets/images/download.svg';
import { Fragment, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import {
	type ReportDownloadType,
	type ReportType,
} from 'src/store/Courses/actions';
import { type RootState } from 'src/store';
import { useIsMobile } from 'src/helpers';
import { useSelector } from 'react-redux';
import { useStyles } from './Reports.styles';
import clsx from 'clsx';

import { AdvancesDialog } from './AdvancesDialog';
import { CertificatesDialog } from './CertificatesDialog';

interface Props {
	type: ReportType;
	handleOpen: () => void;
}

export function ReportButtons({ handleOpen, type }: Props) {
	const classes = useStyles();
	const isMobile = useIsMobile();
	const data = useSelector(
		(state: RootState) => state.courses.reports[type].data,
	);

	const [dialog, setDialog] = useState<{
		open: boolean;
		type: ReportDownloadType;
	}>({ open: false, type: 'advances' });
	const [certificatesOpen, setCertificatesOpen] = useState(false);

	return data.length > 0 ? (
		<Fragment>
			<AdvancesDialog
				handleOpen={() => {
					setDialog({ open: false, type: 'advances' });
				}}
				open={dialog.open}
				type={dialog.type}
			/>

			<CertificatesDialog
				handleOpen={() => {
					setCertificatesOpen(false);
				}}
				open={certificatesOpen}
			/>

			<Grid
				alignItems={'flex-start'}
				container
				justify={'space-between'}
				style={{ marginBottom: 32 }}
			>
				<Grid
					container
					item
					justify={'flex-start'}
					md={6}
					spacing={2}
					xs={12}
				>
					<Grid
						className={classes.certificateButton}
						item
						md={4}
						xs={12}
					>
						<div
							className={clsx(classes.card, {
								[classes.disabled]: isMobile,
								[classes.button]: !isMobile,
							})}
							onClick={() => {
								if (!isMobile) setCertificatesOpen(true);
							}}
						>
							<CertificateIcon className={classes.downloadIcon} />

							<Typography> Constancias </Typography>
						</div>
					</Grid>
				</Grid>

				<Grid
					container
					item
					justify={'flex-end'}
					md={6}
					spacing={2}
					xs={12}
				>
					<Grid item md={6} xs={12}>
						<div
							className={clsx(classes.card, classes.button)}
							onClick={() => {
								setDialog({ open: true, type: 'advances' });
							}}
						>
							<DownloadIcon className={classes.downloadIcon} />

							<Typography> Bitácora de avance </Typography>
						</div>
					</Grid>

					<Grid item md={6} xs={12}>
						<div
							className={clsx(classes.card, {
								[classes.disabled]: isMobile,
								[classes.button]: !isMobile,
							})}
							onClick={() => {
								setDialog({
									open: true,
									type: 'qualifications',
								});
							}}
						>
							<DownloadIcon className={classes.downloadIcon} />

							<Typography> Reporte calificaciones </Typography>
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	) : (
		<Fragment />
	);
}
